/* Kitcito: one complete kit at COP 100,000, excluding gifts and gift cards.
   Storefront reconciliation; this is not a server-side checkout validation. */
(() => {
  const productId = 10462324392236, variantId = 54057254551852, threshold = 10000000;
  const plan = cart => {
    const gifts = cart.items.filter(i => Number(i.product_id) === productId);
    const amount = cart.items.filter(i => Number(i.product_id) !== productId && !i.gift_card)
      .reduce((sum, i) => sum + i.final_line_price, 0);
    const eligible = amount >= threshold;
    const keep = eligible ? gifts.find(i => Number(i.variant_id) === variantId) : null;
    const updates = {};
    gifts.forEach(i => { const qty = i === keep ? 1 : 0; if (i.quantity !== qty) updates[i.key] = qty; });
    return {eligible, amount, updates, add: eligible && !keep};
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = {plan}; return; }
  if (window.TLKitcito) return;
  const root = window.Shopify?.routes?.root || '/';
  let pending, timer;
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(body)
    } : {cache:'no-store'});
    if (!response.ok) throw new Error('No pudimos confirmar Kitcito Gratis. Revisa el carrito e inténtalo de nuevo.');
    return response.json();
  };
  const refresh = cart => {
    const Cart = customElements.get('cart-element');
    if (Cart && cart.sections) {
      Cart.fillBasket(cart.items); Cart.updateTotals(cart.item_count); Cart.updateAllHtml(cart.sections);
    }
  };
  const ensure = () => {
    if (pending) return pending;
    pending = (async () => {
      let cart = await request('cart.js');
      const action = plan(cart);
      const sections = customElements.get('cart-element')?.sections || ['cart-drawer','cart-desktop','cart-mobile'];
      let changed = false;
      if (Object.keys(action.updates).length) {
        cart = await request('cart/update.js', {updates:action.updates, sections}); changed = true;
      }
      if (action.add) {
        await request('cart/add.js', {items:[{id:variantId,quantity:1,properties:{'Regalo':'Kitcito Gratis — Lipstick Oro + Stamp Eyeliner + Porta celular'}}]});
        cart = await request('cart/update.js', {updates:{},sections}); changed = true;
      }
      // Verify the returned cart, including quantity, before allowing checkout.
      const remaining = plan(cart);
      if (remaining.add || Object.keys(remaining.updates).length) throw new Error('Revisa Kitcito Gratis antes de continuar.');
      if (changed) refresh(cart);
      document.querySelectorAll('[data-tl-gift-error]').forEach(el=>el.remove());
      return cart;
    })().finally(()=>{ pending = null; });
    return pending;
  };
  const showError = error => {
    document.querySelectorAll('.cart--checkout-button').forEach(button=>{
      button.removeAttribute('aria-busy');
      let message = button.parentElement.querySelector('[data-tl-gift-error]');
      if (!message) { message=document.createElement('p'); message.dataset.tlGiftError=''; message.setAttribute('role','alert'); message.style.color='#b10c20'; button.after(message); }
      message.textContent=error.message;
    });
  };
  const checkout = async () => { try { await ensure(); location.href=root+'checkout'; } catch(error) { showError(error); throw error; } };
  window.TLKitcito={ensure,checkout};
  const schedule = () => { clearTimeout(timer); timer=setTimeout(()=>ensure().catch(showError),150); };
  window.addEventListener('theme:cart:updated',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('click',event=>{
    if (!event.target.closest('.cart--checkout-button')) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout().catch(()=>{});
  },true);
  document.addEventListener('submit',event=>{
    if (!event.target.matches('.cart--form') || (event.submitter && event.submitter.name !== 'checkout')) return;
    event.preventDefault(); checkout().catch(()=>{});
  },true);
  schedule();
})();
